import { makeStyles } from '@material-ui/core/styles'

/**
 * Field styles for the Add Resource wizard. Mirrors the visual identity of
 * the Create Service form (rounded outlined fields with the portal's purple
 * accent border and red error border) — see TextBox.js / CreateServiceStyles.
 */
export const useWizardFieldStyles = makeStyles((theme) => ({
	textField: {
		'& .MuiOutlinedInput-root': {
			borderRadius: 8
		},
		'& .MuiOutlinedInput-notchedOutline': {
			borderColor: theme.palette.colors.purple,
			borderRadius: 8
		},
		'& .Mui-error .MuiOutlinedInput-notchedOutline': {
			borderColor: theme.palette.colors.red
		}
	},
	label: {
		fontSize: '0.75rem',
		marginBottom: theme.spacing(0.5)
	},
	error: {
		marginTop: theme.spacing(0.5)
	},
	selectStyles: () => ({
		menu: (base) => ({ ...base, zIndex: 62, maxHeight: 220 }),
		menuList: (base) => ({ ...base, maxHeight: 220, paddingTop: 0 }),
		menuPortal: (base) => ({ ...base, zIndex: 9999 }),
		clearIndicator: (base) => ({ ...base, display: 'none' }),
		control: (base, state) => ({
			...base,
			borderRadius: 8,
			borderColor: theme.palette.colors.purple,
			minHeight: 40,
			boxShadow: state.isFocused ? `0 0 0 1px ${theme.palette.colors.purple}` : 'none',
			'&:hover': {
				borderColor: theme.palette.colors.purple
			}
		}),
		controlError: (base, state) => ({
			...base,
			borderRadius: 8,
			borderColor: theme.palette.colors.red,
			minHeight: 40,
			boxShadow: state.isFocused ? `0 0 0 1px ${theme.palette.colors.red}` : 'none',
			'&:hover': {
				borderColor: theme.palette.colors.red
			}
		})
	})
}))

/**
 * Build a react-select `styles` config that matches the portal's outlined-purple
 * field treatment, with red border when the field is in error.
 */
export const buildReactSelectStyles = (theme, hasError) => ({
	menu: (base) => ({ ...base, zIndex: 62, maxHeight: 220 }),
	menuList: (base) => ({ ...base, maxHeight: 220, paddingTop: 0 }),
	menuPortal: (base) => ({ ...base, zIndex: 9999 }),
	clearIndicator: (base) => ({ ...base, display: 'none' }),
	control: (base, state) => ({
		...base,
		borderRadius: 8,
		borderColor: hasError
			? theme.palette.colors.red
			: state.isFocused
				? theme.palette.colors.purple
				: theme.palette.colors.purple,
		minHeight: 40,
		boxShadow: state.isFocused
			? `0 0 0 1px ${hasError ? theme.palette.colors.red : theme.palette.colors.purple}`
			: 'none',
		'&:hover': {
			borderColor: hasError ? theme.palette.colors.red : theme.palette.colors.purple
		}
	})
})
